{
    "NAME": "AdminOverviewLanguage",
    "AdminOverview_Intro": "Choose a CME, telephony server, and partition to see available admin areas and current counts.",
    "AdminOverview_Search_Helper": "Search applies to the counts shown here and carries into the selected admin page.",
    "AdminOverview_State_Loading": "Loading",
    "AdminOverview_State_Error": "Unable to load the latest count",
    "AdminOverview_State_NoTelephonyServer": "No telephony server in scope",
    "AdminOverview_State_SelectTelephonyServer": "Select a telephony server to load this count",
    "AdminOverview_State_SelectTelephonyServerAndPartition": "Select a telephony server and partition to load this count",
    "AdminOverview_State_SelectPartition": "Select a specific partition to view this count",
    "AdminOverview_State_MessagesLegacy": "Legacy administration page",
    "AdminOverview_State_DatabaseLegacy": "Legacy administration page",
    "AdminOverview_Tile_Cme_Title": "CMEs",
    "AdminOverview_Tile_Cme_Subtitle": "Service structure",
    "AdminOverview_Tile_Cme_Summary": "Child CMEs",
    "AdminOverview_Tile_Cme_Aria": "Open CMEs",
    "AdminOverview_Tile_Telsys_Title": "Telephony Servers",
    "AdminOverview_Tile_Telsys_Subtitle": "Platform estate",
    "AdminOverview_Tile_Telsys_Summary": "Total Servers",
    "AdminOverview_Tile_Telsys_Aria": "Open Telephony Servers",
    "AdminOverview_Tile_Partitions_Title": "Partitions",
    "AdminOverview_Tile_Partitions_Subtitle": "Partition scope",
    "AdminOverview_Tile_Partitions_Summary": "Partitions",
    "AdminOverview_Tile_Partitions_Aria": "Open Partitions",
    "AdminOverview_Tile_Users_Title": "Users",
    "AdminOverview_Tile_Users_Subtitle": "Application access",
    "AdminOverview_Tile_Users_Summary": "Users",
    "AdminOverview_Tile_Users_Aria": "Open Users",
    "AdminOverview_Tile_Devices_Title": "Devices",
    "AdminOverview_Tile_Devices_Subtitle": "Endpoint inventory",
    "AdminOverview_Tile_Devices_Summary": "Devices",
    "AdminOverview_Tile_Devices_Aria": "Open Devices",
    "AdminOverview_Tile_Devices_Extension": "Extension",
    "AdminOverview_Tile_Devices_ExtensionTrunking": "Extension (Trunking)",
    "AdminOverview_Tile_Devices_ExtensionHospitality": "Extension (Hospitality)",
    "AdminOverview_Tile_Devices_Groups": "Groups",
    "AdminOverview_Tile_Devices_AutoAttendant": "Auto Attendant",
    "AdminOverview_Tile_Agents_Title": "Agents",
    "AdminOverview_Tile_Agents_Subtitle": "Queue operations",
    "AdminOverview_Tile_Agents_Summary": "Agents",
    "AdminOverview_Tile_Agents_Aria": "Open Agents",
    "AdminOverview_Tile_Directory_Title": "Directory",
    "AdminOverview_Tile_Directory_Subtitle": "Contact records",
    "AdminOverview_Tile_Directory_Summary": "Directories",
    "AdminOverview_Tile_Directory_Aria": "Open Directory",
    "AdminOverview_Tile_Codes_Title": "Codes",
    "AdminOverview_Tile_Codes_Subtitle": "Code management",
    "AdminOverview_Tile_Codes_Summary": "Codes",
    "AdminOverview_Tile_Codes_Aria": "Open Codes",
    "AdminOverview_Tile_Recording_Title": "Recording",
    "AdminOverview_Tile_Recording_Subtitle": "Integrations",
    "AdminOverview_Tile_Recording_Summary": "Recordings",
    "AdminOverview_Tile_Recording_Aria": "Open Recording",
    "AdminOverview_Tile_Messages_Title": "Messages",
    "AdminOverview_Tile_Messages_Subtitle": "Legacy tools",
    "AdminOverview_Tile_Messages_Aria": "Open Messages",
    "AdminOverview_Tile_Database_Title": "Database",
    "AdminOverview_Tile_Database_Subtitle": "Legacy tools",
    "AdminOverview_Tile_Database_Aria": "Open Database"
}
